module.exports = __webpack_public_path__ + "static/img/slider-1.37297e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/slider-1.jpg
// module id = QGUJ
// module chunks = 7